import React from 'react'
import ResetPasswordPage from './ResetPasswordPage'

export * from './ResetPasswordPage'
export default React.memo(ResetPasswordPage)
